/** Same recursive secret-key prohibition for every builder authoring persistence boundary. */
const PROHIBITED_KEY_PATTERN = /(token|secret|credential|password|oauth|accessToken|refreshToken|apiKey|apiSecret)/i;
export function findStudyBuilderProhibitedField(value, path = 'draft') {
    if (!value || typeof value !== 'object')
        return null;
    for (const [key, nested] of Object.entries(value)) {
        if (!Array.isArray(value) && PROHIBITED_KEY_PATTERN.test(key))
            return `${path}.${key}`;
        const found = findStudyBuilderProhibitedField(nested, `${path}.${key}`);
        if (found)
            return found;
    }
    return null;
}
//# sourceMappingURL=study-builder-draft-validation.js.map